/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import { i18n } from '@lingui/core';
import { useContext } from 'react';
import { getPlaceholderValue } from '../Placeholder/PlaceholderResover';
import { DocumentContext } from '../Context/DocumentContextV2';
import { ContractContext } from '../Context/ContractContextV2';
import { useEventData } from '../Context/EventParticipationContextV2';
import { ValidationS } from '../ValidationS';
import { ContactDetailCtx } from '../Context/ContactDetailsContext';

// eslint-disable-next-line import/prefer-default-export
export const usePlaceholderValue = (placeholderId: string) => {
  const { event, customer, location: eventLocation, customAttributeValues } = useEventData();
  const documentCtx = useContext(DocumentContext);
  const contactDetailsCtx = useContext(ContactDetailCtx);
  const contractCtx = useContext(ContractContext);
  // Try to resolve document entity from document or either contract context in following order
  const _document = ValidationS.hasProperties(documentCtx)
    ? documentCtx.bookitupDocument
    : ValidationS.hasProperties(contractCtx)
    ? contractCtx.bookitupDocument
    : null;
  const planningGroup = ValidationS.hasProperties(documentCtx) ? documentCtx.planningGroup : null;

  return getPlaceholderValue(placeholderId, i18n, {
    event,
    customer: customer ?? contactDetailsCtx.contact,
    eventLocation,
    planningGroup,
    customAttributeValues,
    _document,
    contract: contractCtx ? contractCtx.contract : undefined,
  });
};
